export function Wordmark({ className = '' }: { className?: string }) {
  return <span className={`font-display text-lg font-bold tracking-[0.18em] text-ink ${className}`}>SIMON</span>;
}
